import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { ROUTE_CONSTANTS } from './shared/constants/route-constant'

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/container-layout/container-layout.module').then((m) => m.ContainerLayoutModule),
  },
  {
    path: 'health',
    loadChildren: () => import('./pages/health-check/health-check.module').then((m) => m.HealthCheckModule),
  },
  {
    path: '#/verify_account',
    loadChildren: () => import('./pages/activate-account/activate-account.module').then((m) => m.ActivateAccountModule),
  },
  {
    path: 'verify_account',
    loadChildren: () => import('./pages/activate-account/activate-account.module').then((m) => m.ActivateAccountModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./pages/sso-callback/sso-callback.module').then((m) => m.SsoCallbackModule),
  },
  { path: 'authorize', loadChildren: () => import('./pages/authorize/authorize.module').then((m) => m.AuthorizeModule) },
  {
    path: '**',
    redirectTo: ROUTE_CONSTANTS.AUTHORIZE_PAGES,
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
